import { requestStreamMQTT } from './mqttutils/mqttservice';
import {requestStream} from './rsocketutils/rsocket.service'
import clientconfig from './service.utils';

class LogsService {
 gelogmessages(token:string,start:number, end:number, level:string, onnextCallback:(data:string)=>void, errorCallback:(data:string)=>void) {
   if (clientconfig.clientType){
      requestStreamMQTT('logs/messages',{token:token, start:start, end:end, level: level},onnextCallback)
   }
   else{
    requestStream({token:token, start:start, end:end, level: level},'logs/messages', onnextCallback,errorCallback); 
   }
 }
}

export default new LogsService;